/**
 * Created by xiaojiang on 2017/10/30.
 */
import Vue from 'vue'
import vueRouter from 'vue-router'
Vue.use(vueRouter)

//登录页
const sign_page = resolve => require(['../../components/sign/sign.vue'], resolve)

//引导页
const root_page = resolve => require(['../../components/main/boot.vue'], resolve)

//主页
const home_page = resolve => require(['../../components/main/home-page/home.vue'], resolve)

//官网后台页面
const official_network = resolve => require(['../../components/main/official-network/official-network.vue'], resolve)

//主页->导航+内容路由容器
const main_page = resolve => require(['../../components/main/main.vue'], resolve)

//主页->公共头部
const pub_head = resolve => require(['../../components/main/pub-head.vue'], resolve)


//产品管理->固件版本管理
const firmware_version = resolve => require(['../../components/main/software-version-manage/firmware-version.vue'], resolve)

//产品管理->APP管理
const app_manage = resolve => require(['../../components/main/software-version-manage/app-manage.vue'], resolve)

//产品管理->拓展文件管理->拓展文件类型
const extension_doc = resolve => require(['../../components/main/software-version-manage/extension-document.vue'], resolve)

//产品管理->拓展文件管理->拓展文件信息
const extension_infor = resolve => require(['../../components/main/software-version-manage/extension-document-infor.vue'], resolve)

//产品管理->整机产品
const machine_type = resolve => require(['../../components/main/software-version-manage/machine-type.vue'], resolve)
const machine_type_add = resolve => require(['../../components/main/software-version-manage/machine-typmanage-sub/machine-type-add.vue'], resolve)

//电子资料->汽油资料库
const gasoline_data = resolve => require(['../../components/main/electronic-data/gasoline-data.vue'], resolve)

//电子资料->柴油资料库
const diesel_data = resolve => require(['../../components/main/electronic-data/diesel-data.vue'], resolve)



//汽车管理->多语言管理
const multi_language = resolve => require(['../../components/main/automobile-manage/multi-language.vue'], resolve)

//汽车管理->汽车品牌
const automobile_brand = resolve => require(['../../components/main/automobile-manage/automobile-brand.vue'], resolve)

//汽车管理->汽车索引
const auto_indexing = resolve => require(['../../components/main/automobile-manage/auto-indexing.vue'], resolve)




//老版车型管理->车系维护
const car_maintain = resolve => require(['../../components/main/car-classify/car-maintain.vue'], resolve)

//老版车型管理->车组维护
const emu_maintain = resolve => require(['../../components/main/car-classify/emu-maintain.vue'], resolve)

//老版车型管理->车型维护
const models_maintain = resolve => require(['../../components/main/car-classify/models-maintain.vue'], resolve)

//老版车型管理->车型文件
const models_file = resolve => require(['../../components/main/car-classify/models-file.vue'], resolve)


//新版车型管理->新版车系维护
const car_care_new = resolve => require(['../../components/main/car-classify-new/car-care-new.vue'], resolve)

//新版车型管理->新版车组维护
const emu_care_new = resolve => require(['../../components/main/car-classify-new/emu-care-new.vue'], resolve)

//新版车型管理->新版车型维护
const models_care_new = resolve => require(['../../components/main/car-classify-new/models-care-new.vue'], resolve)

//新版车型管理->新版车型文件维护
const models_car_file = resolve => require(['../../components/main/car-classify-new/models-car-file.vue'], resolve)

//新版车型管理->新版车标类型维护
const logo_type = resolve => require(['../../components/main/car-classify-new/logo-type.vue'], resolve)

//新版车型管理->新版车标文件维护
const logo_file = resolve => require(['../../components/main/car-classify-new/logo-file.vue'], resolve)

//ECU刷写->康明斯刷写
const KMS_data_package = resolve => require(['../../components/main/ECU-flash/KMS-data-package/KMS-data-package.vue'], resolve)

const data_up_page = resolve => require(['../../components/main/ECU-flash/KMS-data-package/data_up_page.vue'], resolve)

//ECU刷写->博世刷写
const BS_data_package = resolve => require(['../../components/main/ECU-flash/BS-data-package/BS-data-package.vue'], resolve)

//ECU刷写->德尔福刷写
const Other_data_package = resolve => require(['../../components/main/ECU-flash/Other-data-package/Other-data-package.vue'], resolve)

//ECU刷写->马牌刷写
const MP_data_package = resolve => require(['../../components/main/ECU-flash/MP-data-package/MP-data-package.vue'], resolve)

//ECU刷写->南岳刷写
const NY_data_package = resolve => require(['../../components/main/ECU-flash/NY-data-package/NY-data-package.vue'], resolve)

//ECU用户上传数据
const user_upload = resolve => require(['../../components/main/ECU-flash/user-upload/user-upload.vue'], resolve)






//已售设备管理->已售设备
const sold_equipment = resolve => require(['../../components/main/sold-equipment-manage/sold-equipment.vue'], resolve)

//已授权管理
const userAccredit = resolve => require(['../../components/main/sold-equipment-manage/sold-equipment-sub/userAccredit.vue'], resolve)

const sold_equipment_new = resolve => require(['../../components/main/sold-equipment-manage/sold-equipment-sub/sold-equipment-editor.vue'], resolve)
//已售设备管理->设备授权->固件授权
const firmware_accredit_sold = resolve => require(['../../components/main/sold-equipment-manage/sold-equipment-sub/firmware-accredit-sold.vue'], resolve)
//已售设备管理->设备授权->app授权
const app_accredit_sold = resolve => require(['../../components/main/sold-equipment-manage/sold-equipment-sub/app-accredit-sold.vue'], resolve)
//已售设备管理->设备授权->扩展文件授权
const extend_accredit_sold = resolve => require(['../../components/main/sold-equipment-manage/sold-equipment-sub/extend-accredit-sold.vue'], resolve)
//已售设备管理->设备授权->车型文件授权
const model_accredit_sold = resolve => require(['../../components/main/sold-equipment-manage/sold-equipment-sub/model-accredit-sold.vue'], resolve)





//软件同步管理->一键同步
const sync_manage = resolve => require(['../../components/main/sync-manage/sync-manage.vue'], resolve)


//用户管理->用户账号列表
const user_manage = resolve => require(['../../components/main/user-manage/user-manage-sub/user-manage.vue'], resolve)
//用户管理->用户账号列表->查看记录
// const account_data_record = resolve => require(['../../components/main/user-manage/user-manage-sub/account-data-record.vue'], resolve)
//用户管理->用户账号列表->查看记录->个人详情
const checkDetail_config = resolve => require(['../../components/main/user-manage/user-manage-sub/account-data-record-detail.vue'], resolve)
//用户管理->用户账号列表->查看记录->授权
const authorize_config = resolve => require(['../../components/main/user-manage/user-manage-sub/account-data-record-authorize.vue'], resolve)
//用户管理->用户账号列表->查看记录->授权->历史记录
const record_config = resolve => require(['../../components/main/user-manage/user-manage-sub/account-data-record-authorize-history.vue'], resolve)



//授权管理->设备授权
const equipment_accredit = resolve => require(['../../components/main/accredit-manage/equipment-accredit.vue'], resolve)
//投诉管理->设备授权->固件授权
const firmware_accredit = resolve => require(['../../components/main/accredit-manage/equipment-accredit-sub/firmware-accredit.vue'], resolve)
//投诉管理->设备授权->app授权
const app_accredit = resolve => require(['../../components/main/accredit-manage/equipment-accredit-sub/app-accredit.vue'], resolve)
//投诉管理->设备授权->扩展文件授权
const extend_accredit = resolve => require(['../../components/main/accredit-manage/equipment-accredit-sub/extend-accredit.vue'], resolve)
//投诉管理->设备授权->车型文件授权
const model_accredit = resolve => require(['../../components/main/accredit-manage/equipment-accredit-sub/model-accredit.vue'], resolve)
//投诉管理->设备授权->已售设备查看
const granted = resolve => require(['../../components/main/accredit-manage/equipment-accredit-sub/granted.vue'], resolve)


//投诉管理->投诉列表
const appeal_manage = resolve => require(['../../components/main/appeal-manage/appeal-manage.vue'], resolve)

//诊断管理->诊断报告
const diagnostic_report = resolve => require(['../../components/main/diagnostic-report/diagnostic-report.vue'], resolve)


//英文官网管理->新闻管理
const news_manage = resolve => require(['../../components/main/English-website-manage/news-manage.vue'], resolve)

//英文官网管理->产品管理
const product_manage = resolve => require(['../../components/main/English-website-manage/product-manage.vue'], resolve)

//英文官网管理->图片管理
const photo_manage = resolve => require(['../../components/main/English-website-manage/photo-manage.vue'], resolve)

//英文官网管理->视屏管理
const video_manage = resolve => require(['../../components/main/English-website-manage/video-manage.vue'], resolve)


//安徽官网管理->新闻管理
const anhui_news_manage = resolve => require(['../../components/main/anhui-website-manage/news-manage.vue'], resolve)

//安徽官网管理->产品管理
const anhui_product_manage = resolve => require(['../../components/main/anhui-website-manage/product-manage.vue'], resolve)
// const anhui_product_manage = resolve => require(['../../components/main/Chinese-website-manage/product-manage.vue'], resolve)

//安徽官网管理->图片管理
const anhui_photo_manage = resolve => require(['../../components/main/anhui-website-manage/photo-manage.vue'], resolve)

//安徽官网管理->经销商管理
const anhui_video_manage = resolve => require(['../../components/main/anhui-website-manage/video-manage.vue'], resolve)

//安徽官网管理->招聘信息
const anhui_recruit_manage = resolve => require(['../../components/main/anhui-website-manage/recruit-manage.vue'], resolve)

//安徽官网管理->信息查询
const anhui_infomation_manage = resolve => require(['../../components/main/anhui-website-manage/information-search.vue'], resolve)

//安徽官网管理->服务介绍
const anhui_bussiness_manage = resolve => require(['../../components/main/anhui-website-manage/Business.vue'], resolve)

//俄文官网管理->新闻管理
const Russian_news = resolve => require(['../../components/main/Russian-website-manage/news-manage.vue'], resolve)

//俄文官网管理->产品管理
const Russian_product = resolve => require(['../../components/main/Russian-website-manage/product-manage.vue'], resolve)

//俄文官网管理->图片管理
const Russian_photo = resolve => require(['../../components/main/Russian-website-manage/photo-manage.vue'], resolve)

//俄文官网管理->视频管理
const Russian_video = resolve => require(['../../components/main/Russian-website-manage/video-manage.vue'], resolve)

const Russian_information = resolve => require(['../../components/main/Russian-website-manage/technical-information.vue'], resolve)




const Russian_services = resolve => require(['../../components/main/Russian-website-manage/technical-services.vue'], resolve)

/*const Russian_information = resolve => require(['../../components/main/Russian-website-manage/technical-information.vue'], resolve)

const Russian_concat = resolve => require(['../../components/main/Russian-website-manage/company-concat.vue'], resolve)
*/

//中文官网-> 新闻管理
const Chinese_news = resolve => require(['../../components/main/Chinese-website-manage/news-manage.vue'], resolve)

//中文官网 -> 图片管理
const Chinese_photo = resolve => require(['../../components/main/Chinese-website-manage/photo-manage.vue'], resolve)

//中文官网 -> 产品管理
const Chinese_product = resolve => require(['../../components/main/Chinese-website-manage/product-manage.vue'], resolve)

//中文官网 -> 年报
const Chinese_report = resolve => require(['../../components/main/Chinese-website-manage/report-manage.vue'], resolve)

//中文官网 -> 通知
const Chinese_Notice = resolve => require(['../../components/main/Chinese-website-manage/notice-manage.vue'], resolve)

//中文官网 -> 招聘信息
const Chinese_Recruit = resolve => require(['../../components/main/Chinese-website-manage/recruit-manage.vue'], resolve)

//中文官网 -> 信息查询
const Chinese_search = resolve => require(['../../components/main/Chinese-website-manage/information-search.vue'], resolve)

//中文官网 -> 服务介绍
const Chinese_Business = resolve => require(['../../components/main/Chinese-website-manage/Business.vue'], resolve)


//软件同步->固件
const firmware_synchronous = resolve => require(['../../components/main/software-synchronous/firmware-synchronous.vue'], resolve)

//软件同步->app
const app_synchronous = resolve => require(['../../components/main/software-synchronous/app-synchronous.vue'], resolve)

//软件同步->car
const car_synchronous = resolve => require(['../../components/main/software-synchronous/car-synchronous.vue'], resolve)


//故障码->柴油故障码
const diesel_fault = resolve => require(['../../components/main/fault-code/diesel-fault.vue'], resolve)


//换机数据->换机数据
const change_machine = resolve => require(['../../components/main/change-machine/change-machine.vue'], resolve)


export default new vueRouter({
    mode: 'hash',
    // base:'FcarOperateWeb',
    // mode:'history',/*特别注意：history模式打包上线后，需要后台配置*/

    routes: [
        {
            path: "/",
            redirect: "/login2"
        },
        {
            path: "/login2",
            component: sign_page
        },
        {
            path: "/main-page",
            component: main_page,
            children: [
                {
                    path: "/",
                    redirect: "/index"
                },
                {
                    path: "/index",
                    component: root_page
                },
                {
                  path: "/home-page",
                  component: home_page
                },
                {
                  path: "/official-network",
                  component: official_network
                },
                {
                    path: "pub-head",
                    component: pub_head,
                    children: [
                        {
                          path: "machine-type-add",//产品管理->固件版本管理
                          component: machine_type_add
                        },
                        {
                            path: "firmware-version",//产品管理->固件版本管理
                            component: firmware_version
                        },
                        {
                          path: "app-manage",//产品管理->APP管理
                          component: app_manage
                        },
                        {
                          path: "extension-doc",//产品管理->扩展文件管理
                          component: extension_doc
                        },
                        {
                          path: "extension-infor",//产品管理->扩展文件管理
                          component: extension_infor
                        },
                        {
                          path: "machine-type",//产品管理->整机产品
                          component: machine_type
                        },


                        {
                          path: "gasoline-data",//电子资料->汽油资料库
                          component: gasoline_data
                        },
                        {
                          path: "diesel-data",//电子资料->柴油资料库
                          component: diesel_data
                        },

                        {
                          path: "multi-language",//汽车管理->多语言管理
                          component: multi_language
                        },
                        {
                          path: "automobile-brand",//汽车管理->汽车品牌
                          component: automobile_brand
                        },
                        {
                          path: "auto-indexing",//汽车管理->汽车索引
                          component: auto_indexing,
                          name:"auto_indexing"
                        },


                        {
                          path: "car-maintain",//老版车型管理->车系维护
                          component: car_maintain
                        },
                        {
                          path: "emu-maintain",//老版车型管理->车组维护
                          component: emu_maintain
                        },
                        {
                          path: "models-maintain",//老版车型管理->车型维护
                          component: models_maintain
                        },
                        {
                          path: "models-file",//老版车型管理->车型文件
                          component: models_file
                        },


                        {
                          path: "car-care-new",//新版车型管理->车系维护
                          component: car_care_new
                        },
                        {
                          path: "emu-care-new",//新版车型管理->车组维护
                          component: emu_care_new
                        },
                        {
                          path: "models-care-new",//新版车型管理->车型维护
                          component: models_care_new
                        },

                        {
                          path: "models-car-file",//新版车型管理->车型文件维护
                          component: models_car_file
                        },
                        {
                          path: "logo-type",//新版车型管理->车标类型维护
                          component: logo_type
                        },
                        {
                          path: "logo-file",//新版车型管理->车标文件维护
                          component: logo_file
                        },

                        {
                          path: "KMS-data-package",//ECU数据包管理->康明斯数据包
                          component: KMS_data_package
                        },
                        {
                          path: "data_up_page",//ECU数据包管理->康明斯数据包->上传包
                          component: data_up_page
                        },

                        {
                          path: "BS-data-package",//ECU数据包管理->博世数据包
                          component: BS_data_package
                        },

                        {
                          path: "Other-data-package",//ECU数据包管理->其他数据包
                          component: Other_data_package
                        },

                        {
                          path: "MP-data-package",//ECU数据包管理->马牌数据包
                          component: MP_data_package
                        },

                        {
                          path: "NY-data-package",//ECU数据包管理->南岳数据包
                          component: NY_data_package
                        },
                        {
                          path: "user-upload",//ECU数据包管理->南岳数据包
                          component: user_upload
                        },


                        {
                          path: "sold-equipment",//已售设备管理->已售设备
                          name:"sold_equipment",
                          component: sold_equipment
                        },
                        {
                          path: "userAccredit",//已售设备管理->已售设备
                          name:"userAccredit",
                          component: userAccredit
                        },


                        {
                          path: "sold-equipment-new",//已售设备管理->已售设备->添加新用户
                          component: sold_equipment_new,
                          name:"sold_equipment_new"
                        },

                        {
                          path: "firmware-accredit-sold",//授权管理->固件授权
                          component: firmware_accredit_sold,
                          name:"firmware_accredit_sold"
                        },
                        {
                          path: "app-accredit-sold",//授权管理->app授权
                          component: app_accredit_sold,
                          name:"app_accredit_sold"
                        },
                        {
                          path: "extend-accredit-sold",//授权管理->扩展文件授权
                          component: extend_accredit_sold,
                          name:"extend_accredit_sold",
                        },
                        {
                          path: "model-accredit-sold",//授权管理->车型文件授权
                          component: model_accredit_sold,
                          name:"model_accredit_sold",
                        },





                        {
                          path: "sync-manage",//软件同步管理->一键同步
                          component: sync_manage
                        },





                        {
                          path: "user-manage",//用户管理->用户账号列表
                          name:'user_manage',
                          component: user_manage
                        },
                        /*{
                          path: "account-data-record/:configID",//用户管理->用户账号列表->查看记录
                          component: account_data_record,
                          name:"account_config"
                        },*/
                        {
                          path: "checkDetail-config/:configID",//用户管理->用户账号列表->查看记录->个人详情
                          component: checkDetail_config,
                          name:"checkDetail_config"
                        },
                        {
                          path: "authorize-config/:configID",//用户管理->用户账号列表->汽车诊断授权
                          component: authorize_config,
                          name:"authorize_config"
                        },
                        {
                          path: "record-config/:configID",//用户管理->用户账号列表->汽车诊断授权->授权记录
                          component: record_config,
                          name:"record_config"
                        },

                        {
                          path: "equipment-accredit",//授权管理->设备授权
                          component: equipment_accredit,
                          name:"equipment_accredit"
                        },
                        {
                        path: "firmware-accredit",//授权管理->固件授权
                        component: firmware_accredit,
                        name:"firmware_accredit"
                      },
                      {
                        path: "app-accredit",//授权管理->app授权
                        component: app_accredit,
                        name:"app_accredit"
                      },
                      {
                        path: "extend-accredit",//授权管理->扩展文件授权
                        component: extend_accredit,
                        name:"extend_accredit",
                      },
                      {
                        path: "model-accredit",//授权管理->车型文件授权
                        component: model_accredit,
                        name:"model_accredit",
                      },
                        {
                          path: "granted",//授权管理->查看已售设备授权
                          component: granted,
                          name:"granted",
                        },



                        {
                          path: "appeal-manage",//投诉管理->投诉列表
                          component: appeal_manage
                        },
                        {
                          path:"diagnostic-report",//诊断管理->诊断报告
                          component: diagnostic_report
                        },
                        {
                          path:"news-manage",//英文官网管理->新闻管理
                          component: news_manage
                        },
                        {
                          path:"product-manage",//英文官网管理->产品管理
                          component: product_manage
                        },
                        {
                          path:"photo-manage",//英文官网管理->图片管理
                          component: photo_manage
                        },
                        {
                          path:"video-manage",//英文官网管理->视频管理
                          component: video_manage
                        },
                        {
                          path:"anhui_news-manage",//安徽官网管理->新闻管理
                          component: anhui_news_manage
                        },
                        {
                          path:"anhui_product-manage",//安徽官网管理->产品管理
                          component: anhui_product_manage
                        },
                        {
                          path:"anhui_photo-manage",//安徽官网管理->图片管理
                          component: anhui_photo_manage
                        },
                        {
                          path:"anhui_video-manage",//安徽官网管理->经销商管理
                          component: anhui_video_manage
                        },
                        {
                          path:"anhui_recruit_manage",//安徽官网管理->招聘信息
                          component: anhui_recruit_manage
                        },
                        {
                          path:"anhui_infomation_manage",//安徽官网管理->信息查询
                          component: anhui_infomation_manage
                        },
                        {
                          path:"anhui_bussiness_manage",//安徽官网管理->服务介绍
                          component: anhui_bussiness_manage
                        },


                      {
                        path:"Russian-news",//俄文官网管理->新闻管理
                        component: Russian_news
                      },
                      {
                        path:"Russian-product",//俄文官网管理->产品管理
                        component: Russian_product
                      },
                      {
                        path:"Russian-photo",//俄文官网管理->图片管理
                        component: Russian_photo
                      },
                      {
                        path:"Russian-video",//俄文官网管理->视频管理
                        component: Russian_video
                      },
                      {
                        path:"Russian-information",//俄文官网管理->信息管理
                        component: Russian_information
                      },

                  {
                        path:"Russian-services",//俄文官网管理->视频管理
                        component:  Russian_services
                      },
                    /*      {path:"Russian-information",//俄文官网管理->视频管理
                       component:  Russian_information
                     },

                     {
                       path:"Russian-concat",//俄文官网管理->视频管理
                       component: Russian_concat
                     },*/
                      {
                        path:"Chinese-news",//中文官网管理->新闻管理
                        component: Chinese_news
                      },
                      {
                        path:"Chinese-photo",//中文官网管理->新闻管理
                        component: Chinese_photo
                      },
                      {
                        path:"Chinese-product",//中文官网管理->产品管理
                        component:Chinese_product
                      },
                      {
                        path:"Chinese-report",//中文官网管理->年报
                        component:Chinese_report
                      },
                      {
                        path:"Chinese-Notice", //中文官网管理->公告
                        component:Chinese_Notice
                      },
                      {
                        path:"Chinese-Recruit", //中文官网管理->招聘信息Chinese_Notice
                        component:Chinese_Recruit
                      },
                      {
                        path:"Chinese-search", //中文官网管理->招聘信息Chinese_Notice
                        component:Chinese_search
                      },
                      {
                        path:"Chinese-Business", //中文官网管理->服务介绍
                        component:Chinese_Business
                      },
                      {
                        path:"diesel-fault", //故障码->柴油故障码
                        component:diesel_fault
                      },
                      {
                        path:"firmware-synchronous",//软件同步->固件
                        component: firmware_synchronous
                      },
                      {
                        path:"app-synchronous",//软件同步->app
                        component: app_synchronous
                      },
                      {
                        path:"car-synchronous",//软件同步->车型
                        component: car_synchronous
                      },
                      {
                        path:"change-machine",//换机数据->换机数据
                        component: change_machine
                      },
                    ]
                }
            ]
        }
    ]
})





// WEBPACK FOOTER //
// ./src/assets/routers/index.js